import CompanyDetails from '../components/CompanyDetails';
import '../components/Sliders';

export default {
  init() {
    // JavaScript to be fired on the home page

    /** Scroll down button in page header */
    document.getElementById('page-header-button').addEventListener('click', e => {
      e.preventDefault();
      window.scrollTo(0, window.innerHeight - document.getElementById('head').getBoundingClientRect().height);
    });

    /** Recent companies */
    const recent = document.getElementById('recent');
    if (recent !== null) {
      for (const articleLink of recent.querySelectorAll('.recent-article a')) {
        articleLink.addEventListener('click', e => {
          e.preventDefault();
          const details = document.getElementById('company-details');
          if (details !== null) {
            new CompanyDetails(e.currentTarget.getAttribute('data-rest-url'), details);
          }
        });
      }
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js